


import React, { useState, useEffect, useRef } from "react";
import { FaMoon, FaBell, FaEnvelope, FaUserCircle, FaBars, FaSignOutAlt, FaUser, FaAddressBook } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import APIEndPoints from "../../middleware/APIEndPoints";


const Header = ({ setOpen }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationsRef = useRef(null);
  const profileRef = useRef(null);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const navigate = useNavigate();


  const getSignOutURL = APIEndPoints.sign_out.url;




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(getSignOutURL, {}, { withCredentials: true });

      localStorage.removeItem('user'); // Replace 'user' with the actual key storing user data

      alert("Logged out successfully.");
      navigate('/'); // Redirect to login page after logout
    } catch (err) {
      console.error("Logout error:", err);
      alert("Logout failed.");
    }
  };


  return (
    <div className="fixed right-0 flex justify-between items-center p-4 bg-gray-900 text-white shadow-md w-full">
      {/* Toggle Sidebar Button (Visible on Small Screens) */}
      <button
        onClick={() => setOpen(prev => !prev)}
        className="md:hidden p-2 bg-gray-800 text-white rounded-md"
      >
        <FaBars size={24} />
      </button>

      {/* Welcome Message */}
      <div className="text-lg font-semibold hidden sm:block lg:ml-72">Welcome, Admin</div>

      {/* Right-Side Controls */}
      <div className="flex items-center space-x-6 relative">
        {/* Dark Mode Toggle */}
        <button className="p-2 hover:bg-gray-800 rounded-md">
          <FaMoon size={20} />
        </button>

        {/* Notifications */}
        <div className="relative" ref={notificationsRef}>
          <button
            className="p-2 hover:bg-gray-800 rounded-md relative"
            onClick={() => setShowNotifications(prev => !prev)}
          >
            <FaBell size={20} />
            <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-48 bg-gray-800 text-white shadow-lg rounded-md p-2">
              <p className="p-2 hover:bg-gray-700 rounded-md">New Message</p>
              <p className="p-2 hover:bg-gray-700 rounded-md">System Update</p>
              <p className="p-2 hover:bg-gray-700 rounded-md">Meeting at 3PM</p>
            </div>
          )}
        </div>

        {/* Messages */}
        <button className="p-2 hover:bg-gray-800 rounded-md">
          <FaEnvelope size={20} />
        </button>

        {/* Profile */}
        <div className="relative" ref={profileRef}>
          <button
            className="p-2 hover:bg-gray-800 rounded-md"
            onClick={() => setShowProfileMenu(prev => !prev)}
          >
            <FaUserCircle size={24} />
          </button>
          {showProfileMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-gray-800 text-white shadow-lg rounded-md p-2">
              <div className="flex items-center p-2 hover:bg-gray-700 rounded-md"><FaUser className="mr-2" /> Profile</div>
              <div className="flex items-center p-2 hover:bg-gray-700 rounded-md"><FaAddressBook className="mr-2" /> Contact</div>
              <div onClick={() => setShowLogoutConfirmation(true)} className="flex items-center p-2 hover:bg-red-600 rounded-md cursor-pointer"><FaSignOutAlt className="mr-2 " /> Logout</div>
            </div>
          )}
        </div>
      </div>
      {/* LOGOUT CONFIRMATION MODAL */}
      {showLogoutConfirmation && (
        <div className='fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center'>
          <div className='bg-white p-6 rounded shadow-lg text-center text-black'>
            <p className='mb-4'>Are you sure you want to log out?</p>
            <div className='flex justify-center space-x-4'>
              <button
                onClick={handleLogout}
                className='bg-red-500 text-white px-4 py-2 rounded'
              >
                Yes
              </button>
              <button
                onClick={() => setShowLogoutConfirmation(false)}
                className='bg-gray-500 text-white px-4 py-2 rounded'
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
